/** Anwendungsweite Konstanten — Pendant zu Client/Config.cs und Program.cs des Altclients. */

export const APP_VERSION = '2026.7.30.1';

/** API-Basis-URL ohne abschließenden Schrägstrich. */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL.replace(/\/+$/, '');

export const GRAPH_BASE_URL = 'https://graph.microsoft.com';

/** Kennzeichnet jede API-Anfrage als Aufruf dieses Clients. */
export const API_SOURCE_HEADER = { name: 'iwm-src', value: 'enders/chinaapp/client' } as const;

export const SIDEBAR_STATE_KEY = 'iwm-sidebar-state';

/**
 * Gespeicherte Darstellung (REQ-19 §6): `'light' | 'dark'`. Wird als
 * `data-theme` am `<html>`-Element gesetzt — beim Laden vom Inline-Skript in
 * `index.html`, zur Laufzeit von REQ-20.
 */
export const THEME_STORAGE_KEY = 'iwm-theme';

/** Gespeicherte Dichte (REQ-19 §6): `'compact' | 'normal' | 'cozy'` → `data-density`. */
export const DENSITY_STORAGE_KEY = 'iwm-density';

export const CURRENT_APP_STORAGE_KEY = 'currentApp';

export const RETURN_URL_STORAGE_KEY = 'auth-returnUrl';
